<template>
  <div class="preview" :class="{flip: flipStatus}" v-show="visibleStatus">
    <div class="head">
      <p class="type">공정도명</p>
      <p v-html="processInfo.processName" class="title"></p>
      <button @click="()=>flipStatus = !flipStatus">
        {{ flipStatus ? "펼치기" : '접어두기' }}
      </button>
      <button @click="hide">닫기</button>
    </div>
    <div class="control">
      <ul class="info">
        <li>생성/수정일: {{processData.createdDate ? (processData.createdDate) : ''}} {{processData.updatedDate ? '/ '+ (processData.updatedDate) : ''}}</li>
        <li>작성자 : {{processData.userName ? processData.userName : ''}}</li>
      </ul>
      <ZoomSlider @full-screen="fullScreen" :init="1" :min="0.2" :max="3" @change="sizeChange"></ZoomSlider>
    </div>
    <div class="canvas" :class="{load: loading}" id="protocol-preview-area">

    </div>
  </div>
</template>

<script>
import ZoomSlider from '../common/ZoomSlider.vue'
import GO from "gojs";
import mixin from "@/mixins/process";
const goMake = GO.GraphObject.make;

export default {
  mixins: [mixin],
  props: {
    processInfo: Object,
    visible: {
      type: Boolean,
      default(){ return false }
    }
  },
  
  components: {
    ZoomSlider
  },
  data() {
    return {
      diagram: {},
      processData: {},
      visibleStatus: false,
      flipStatus: false,
      loading: false,
    }
  },
  watch: {
    processData:{
      deep: true,
      handler(item) {
        item.createdDate = item.createdDate ? item.createdDate.replace('T', '') : ''
        item.updatedDate = item.updatedDate ? item.updatedDate.replace('T', '') : ''
        if(!item.userName) {
          item.userName = item.user ? item.user.userName : ''
        }
        this.setModel(item);
        this.changeStyle(item.keyOfProtocol);
      },
    },
  },
  mounted(){
    this.emitInterface();
    this.diagramInit();
    this.visibleStatus = this.visible;
  },
  methods: {
    emitInterface() {
      this.$emit('setMethod', {show : this.show, hide: this.hide});
    },
    fullScreen(event) {

    },
    sizeChange(event) {
      this.diagram.scale = event;
      this.$emit('scale-change', event);
    },
    hide() {
      this.visibleStatus = false
      // this.flipStatus = false
      this.$emit('preview-close', null);
      
      // this.diagram = null;
    },
    show() {
      this.visibleStatus = true
      this.flipStatus = false
      // if(!this.diagram) this.init();
      if(this.processInfo) this.getProcessDetail();
    },
    async getProcessDetail(){
      //let response = await this.$wApi.process.detail(null, this.processInfo.processId);
      const data = JSON.parse(this.processInfo.content);
      if(data) {
        this.processData = data;
        Object.assign(this.processData, this.processInfo);
      } else {
        window.wToast("비어있는 공정도 입니다.", { variant: "red" });
      }
    },
    diagramInit() {
      // diagram 설정
      const nodeTemplateMapped = new GO.Map();
      this.releaseDiagram();
      this.refreshNodeStyleMap();
      this.nodeStyleMap.forEach((nodeData, key)=>{
        nodeTemplateMapped.add(
          `${key}`,
          goMake(
            GO.Node, 'Auto', {
              margin:2,
              // locationSpot: GO.Spot.Center,
            },
            new GO.Binding("location", "position", GO.Point.parse).makeTwoWay(GO.Point.stringify),
            goMake(GO.Panel,'Auto', 
              ...nodeData.nodeTemplate,
            ),
          ),
        )
      })
      this.diagram = new GO.Diagram("protocol-preview-area", {
        layout: goMake(GO.LayeredDigraphLayout, {
          isOngoing: false,
          isInitial: false
        }),
        // 확대 정도
        scale: .5,
        maxScale: 3,
        minScale: 0.2,
        linkTemplate: this.linkTemplate,
        nodeTemplateMap: nodeTemplateMapped
      });
      this.diagram.isReadOnly = true;
      this.$emit("update-diagram", this.diagram);
    },
    setModel(item) {
      this.diagram.model = new GO.GraphLinksModel(
        {
          nodeDataArray: item.nodes,
          linkDataArray: item.links,
        }
      );
    },
    changeStyle(keyOfProtocol){
      // 특정 노드를 찾아 투명도 변경
      var node = this.diagram.findNodeForKey(keyOfProtocol);
      node.findObject('checkShape').visible = true;
      },
    }
}
</script>

<style lang="scss" scoped>
.preview {
  display: grid;
  grid-template: 
    'head' auto
    'ctrl' auto
    'view' 1fr
    / 1fr
  ;
  position: absolute; top: 76px; left: 425px;
  width: 855px; height: 650px;
  border: 1px solid #999;
  box-shadow: 0 0 0px #333;
  background-color: #fff;
  overflow: hidden;
  transition: height .3s;
  z-index: 15;

  &.flip {
    height: 45px;
    .control { transform: translateY(-100%) }
    .canvas { transform: translateY(-100%) }
  }

  .head {
    grid-area: head;
    display: flex; align-items: center;
    gap: 8px;
    border-bottom: 1px solid #999;
    min-height: 45px;
    padding: 0 var( --default-gap ) 0 0;
    background:#fff;
    z-index: 1;

    .type {
      display: flex; align-items: center; justify-content: center;
      min-width: 120px;
      border-right: 1px solid #999;
      padding: 14px;
      @include text-prt-sb;
    }
    .title {
      width: 100%;
      position: relative;
      padding: 14px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      @include text-prt-sb;
    }

    button {
      flex-shrink: 0;
      padding: 4px 10px;
      background-color: #eee;
      color: #333;
      @include text-prt-sb;
    }
  }
  .control {
    grid-area: ctrl;
    display: flex; justify-content: space-between; align-items: center;
    padding: var( --default-gap ) 40px;
    .info {
      display: flex; flex-direction: column;
      gap: 8px;
      color: #999
    }
    transition: transform .3s;
  }
  .canvas {
    grid-area: view;
    position: relative;
    height: 510px;
    transition: transform .3s;

    &.load {
      &:after {
        content:'';
        display: block;
        position: absolute; top:0; left:0; right:0; bottom:0;
        background-color: rgba(0,0,0, .4);
      }
    }
  }
}
</style>